import { render, staticRenderFns } from "./goodslist.vue?vue&type=template&id=4506079d&scoped=true&"
import script from "./goodslist.vue?vue&type=script&lang=js&"
export * from "./goodslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4506079d",
  null
  
)

export default component.exports